// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== FLEET BLOCK СТИЛИ ===== */
.fleet-section {
  margin-bottom: 25px;
}

.manufacturer-group {
  margin-bottom: 20px;
}

.manufacturer-title {
  font-size: 16px;
  font-weight: 700;
  color: #1E3A8A;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 6px;
  border-bottom: 2px solid #F59E0B;
}

.manufacturer-icon {
  font-size: 18px;
  color: #F59E0B;
}

.fleet-families {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 15px;
}

/* Кнопка семейства */
.family-link {
  text-decoration: none;
}

.family-button {
  display: inline-block;
  background: linear-gradient(135deg, #1E3A8A 0%, #0F2B6E 100%);
  color: white;
  padding: 10px 20px;
  border-radius: 40px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.family-button:hover {
  background: #F59E0B;
  color: #1E3A8A;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(245, 158, 11, 0.3);
}

.fleet-footer {
  margin-top: 15px;
  text-align: right;
}

.view-all-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #1E3A8A;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
}

.view-all-link:hover {
  color: #F59E0B;
  gap: 10px;
}

/* Загрузка и ошибки */
.fleet-loading {
  text-align: center;
  padding: 20px;
}

.spinner-small {
  width: 30px;
  height: 30px;
  border: 3px solid #E5E7EB;
  border-top-color: #1E3A8A;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.fleet-error {
  text-align: center;
  padding: 20px;
  color: #DC2626;
}

.retry-small {
  background: none;
  border: none;
  cursor: pointer;
  color: #1E3A8A;
  font-size: 18px;
  margin-top: 8px;
  transition: transform 0.2s;
}

.retry-small:hover {
  transform: rotate(180deg);
}

/* Адаптивность */
@media (max-width: 768px) {
  .fleet-families {
    gap: 10px;
  }
  
  .family-button {
    padding: 8px 16px;
    font-size: 12px;
    white-space: normal;
    word-break: keep-all;
  }
}

@media (max-width: 480px) {
  .family-button {
    padding: 6px 12px;
    font-size: 11px;
  }
  
  .manufacturer-title {
    font-size: 14px;
  }
}

/* ===== ИКОНКИ ПРОИЗВОДИТЕЛЕЙ ===== */
.manufacturer-icon {
  font-size: 18px;
  margin-right: 8px;
}

/* Если иконки не отображаются, добавьте fallback */
.fa-airbus:before,
.fa-boeing:before {
  font-family: 'FontAwesome';
}

.fa-airbus:before {
  content: "\\f072"; /* иконка plane как fallback */
}

.fa-boeing:before {
  content: "\\f072"; /* иконка plane как fallback */
}`, "",{"version":3,"sources":["webpack://./react/components/fleetblock.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;AAClD","sourcesContent":["/* ===== FLEET BLOCK СТИЛИ ===== */\n.fleet-section {\n  margin-bottom: 25px;\n}\n\n.manufacturer-group {\n  margin-bottom: 20px;\n}\n\n.manufacturer-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1E3A8A;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 6px;\n  border-bottom: 2px solid #F59E0B;\n}\n\n.manufacturer-icon {\n  font-size: 18px;\n  color: #F59E0B;\n}\n\n.fleet-families {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 15px;\n}\n\n/* Кнопка семейства */\n.family-link {\n  text-decoration: none;\n}\n\n.family-button {\n  display: inline-block;\n  background: linear-gradient(135deg, #1E3A8A 0%, #0F2B6E 100%);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 40px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n\n.family-button:hover {\n  background: #F59E0B;\n  color: #1E3A8A;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(245, 158, 11, 0.3);\n}\n\n.fleet-footer {\n  margin-top: 15px;\n  text-align: right;\n}\n\n.view-all-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #1E3A8A;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.2s;\n}\n\n.view-all-link:hover {\n  color: #F59E0B;\n  gap: 10px;\n}\n\n/* Загрузка и ошибки */\n.fleet-loading {\n  text-align: center;\n  padding: 20px;\n}\n\n.spinner-small {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #E5E7EB;\n  border-top-color: #1E3A8A;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 10px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.fleet-error {\n  text-align: center;\n  padding: 20px;\n  color: #DC2626;\n}\n\n.retry-small {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #1E3A8A;\n  font-size: 18px;\n  margin-top: 8px;\n  transition: transform 0.2s;\n}\n\n.retry-small:hover {\n  transform: rotate(180deg);\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .fleet-families {\n    gap: 10px;\n  }\n  \n  .family-button {\n    padding: 8px 16px;\n    font-size: 12px;\n    white-space: normal;\n    word-break: keep-all;\n  }\n}\n\n@media (max-width: 480px) {\n  .family-button {\n    padding: 6px 12px;\n    font-size: 11px;\n  }\n  \n  .manufacturer-title {\n    font-size: 14px;\n  }\n}\n\n/* ===== ИКОНКИ ПРОИЗВОДИТЕЛЕЙ ===== */\n.manufacturer-icon {\n  font-size: 18px;\n  margin-right: 8px;\n}\n\n/* Если иконки не отображаются, добавьте fallback */\n.fa-airbus:before,\n.fa-boeing:before {\n  font-family: 'FontAwesome';\n}\n\n.fa-airbus:before {\n  content: \"\\f072\"; /* иконка plane как fallback */\n}\n\n.fa-boeing:before {\n  content: \"\\f072\"; /* иконка plane как fallback */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
